import { Field, Image, ImageField, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';
import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from './Testimonials.module.css';

type TestimonialsProps = ComponentProps & {
	fields: {
		Testimonials: {
			fields: {
				Testimonial: Field<string>;
				Name: Field<string>;
				Role: Field<string>;
				Image: ImageField;
			};
		}[];
	};
};

export default function Testimonials(props: TestimonialsProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && props.fields?.Testimonials?.length < 1) {
		return <></>;
	}

	return (
		<section className="maxWidth padX padYL">
			<FieldEditFrame itemId={props.rendering.dataSource ?? undefined} fields={['Testimonials']} header="Edit Testimonials">
				<EditorHelp text={'Click here to select the testimonials'} />
				<div className={styles.testimonialContainer}>
					{props.fields?.Testimonials?.map((testimonial, index) => (
						<div key={index} className={styles.testimonialCard}>
							<Image className={styles.testimonialImage} media={testimonial.fields?.Image} />

							<div className={styles.testimonialCardSection}>
								<Text tag="span" field={testimonial.fields?.Name} className={styles.testimonialCardSectionHeader} />
								<Text tag="span" field={testimonial.fields?.Testimonial} className={styles.testimonialCardSectionText} />
								<Text tag="span" field={testimonial.fields?.Role} className={styles.testimonialCardSectionRole} />
							</div>
						</div>
					))}
				</div>
			</FieldEditFrame>
		</section>
	);
}
